import React from "react";
import AddIcon from "../UIComponents/AddIcon";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { getPortList, deletePortDetails } from "../Actions/PortManagementAPI";
import { getZoneList } from "../Actions/VendorManagementAPI";
/* import { getPortTypeList } from "../Actions/PortManagementAPI"; */
/* import { Multiselect } from "multiselect-react-dropdown"; */
import PortCard from "./PortCard";
import { toast } from "react-toastify";
import axios from "axios";
import API from "../helpers/api";
import { confirmAlert } from "react-confirm-alert";
import $ from "jquery";

let currentuser = JSON.parse(localStorage.getItem("currentUser"));
let Searchdata = {
  PortName: "",
  Country: "",
  Zone: "",
  PortType: [],
  PageNumber: 1,
  PageSize: 20,
};
class PortManagement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchData: {
        PortName: "",
        Country: "",
        Zone: "",
        PortType: [],
        PageNumber: 1,
        PageSize: 20,
      },
      zoneListData: []
    };
    this.SearchPort = this.SearchPort.bind(this);
    this.ClearInput = this.ClearInput.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount() {
    const { dispatch, portSearch, t } = this.props;
    /*   dispatch(getPortTypeList()); */
    if (portSearch) {
      this.state.searchData = portSearch;
    }
    dispatch(getPortList(this.state.searchData));
    this.getZoneList();
    // dispatch(getZoneList());
    dispatch({ type: "SubBannerTitle", data: "Port" });
    let searchitem = this.state.searchData;
    let _this = this;
    this.keyPressHandler = function (event) {
      var keycode = event.keyCode || event.which;
      // if (searchitem.PortName || searchitem.Country /* || searchitem.PortType.length>0 */)

      if (keycode === 13) {
        if (_this.verifySearchItems()) {
          _this.SearchPort(1);
        }
        else {
          toast.success(t('Toast.Success'), {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      }
    }

    $(document).keypress(this.keyPressHandler);
  }

  componentWillUnmount() {

    $(document).off("keypress", this.keyPressHandler);
  }

  getZoneList = () => {
    let url = `${API.equipmentLookups}?lookupType=${"contract type"}`;
    axios.get(url).then((response) => {
      let findId = response.data?.filter((item) => item.lookUpName === "FZM")[0]?.lookUpId;
      let url1 = `${API.equipmentLookups}?lookupType=${"plan type"}&parentId=${findId}`;
      axios.get(url1).then((response) => {
        this.setState({ zoneListData: response.data });
      });
    });
  }
  SearchPort(pgno) {
    const { dispatch } = this.props;
    this.state.searchData.PageNumber = pgno;
    dispatch({ type: "portSearch", data: this.state.searchData });
    dispatch(getPortList(this.state.searchData));
  }

  verifySearchItems = () => {
    // searchData: {
    //   PortName: "",
    //   Country: "",
    //   Zone: "",
    //   PortType: [],
    //   PageNumber: 1,
    //   PageSize: 20,
    // },
    let flag = true;
    const search = this.state.searchData;
    if (search.PortName == "" && search.Country == "" && search.Zone == "") {
      flag = false;
    }
    return flag;
  }

  SearchPort1(pgno) {
    const { dispatch, t } = this.props;
    if (this.verifySearchItems()) {

      this.state.searchData.PageNumber = pgno;
      dispatch({ type: "portSearch", data: this.state.searchData });
      dispatch(getPortList(this.state.searchData));
    }
    else {
      toast.success(t('Toast.Success'), {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }

  handleInputChange(e) {
    let nodeName = e.target.name;
    this.state.searchData[nodeName] = e.target.value;
    this.setState({});
  }

  eyeclick(item) {
    const { dispatch, history } = this.props;
    dispatch({ type: "ShowSidePan", data: true });
    dispatch({ type: "getPortDetailSuccess", data: item });
    history.push(`/Home/PortEdit/${item.portId}`);
  }

  deletePort(item) {
    const { t } = this.props;
    console.log(item, 'port')
    confirmAlert({
      message: `${t("confirmAlertMessage.DeleteMsg")}`,
      buttons: [
        {
          label: `${t("confirmAlertMessage.Yes")}`,
          onClick: () => {
            const { dispatch, PortList } = this.props;
            let port = {
              portId: item.portId,
              portName: item.portName,
              country: item.country,
              isDeleted: true,
              modifiedBy: currentuser.name,
              zoneId: item.zoneId
            };
            // this.props.dispatch(deletePortDetails(port));
            let url = `${API.postPort}`;
            axios
              .put(url, port)
              .then((response) => {
                let searchData = {
                  PortName: "",
                  Country: "",
                  PortType: "",
                  PageNumber: this.state.searchData.PageNumber - 1,
                  PageSize: 20,
                };
                if (
                  PortList.pagination.hasNext === false &&
                  PortList.data.length === 1
                ) {
                  dispatch({ type: "portSearch", data: searchData });
                  dispatch(getPortList(searchData));
                } else {
                  dispatch({ type: "portSearch", data: this.state.searchData });
                  dispatch(getPortList(this.state.searchData));
                }
                dispatch({
                  type: "deletePortDetailSuccess",
                  data: response.data,
                });
                toast.success(`${t("CommonText.CommonDelete")}`, {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
                this.ClearInput()
              })
              .catch((error) => {
                dispatch({
                  type: "deletePortDetailFailure",
                  error: "ERROR",
                });
              });
          },
        },
        {
          label: `${t("confirmAlertMessage.No")}`,
          onClick: () => { },
        },
      ],
    });
  }
  /*   onSelectChange(item) {
      this.state.searchData.PortType = item;
      this.setState({});
  }
  
  onRemoveChange(item) {
      this.state.searchData.PortType = item;
      this.setState({});
  } */

  ClearInput() {
    this.state.searchData.PortName = "";
    this.state.searchData.Country = "";
    this.state.searchData.Zone = 0;
    this.state.searchData.PortType = [];
    this.setState({});
    this.props.dispatch({ type: "portSearch", data: "" });
    this.props.dispatch(getPortList(this.state.searchData));
  }

  NewitemNav = () => {
    this.props.dispatch({ type: "ShowSidePan", data: true });
    this.props.history.push("/Home/PortAdd");
  };

  render() {
    const { showSidePane, PortList,/* portTypeList */ t, zoneList } = this.props;
    return (
      <div className="full-height">
        <div className="pt-3">
          <div className="row">
            <div className={showSidePane ? "col-lg-6" : "col-lg-12"}>
              <div className="row">
                <div className="col-lg-12">
                  <div className="panel-box">
                    <div
                      className="card MM-card-header mb-0"
                      style={{ backgroundColor: "white" }}
                    >
                      <div
                        className="card-body flex"
                        style={{
                          padding: "0rem",
                          backgroundColor: "#1a3464",
                          color: "white",
                        }}
                      >
                        <h5
                          className="card-title ml-2 mt-2 f2"
                          style={{ color: "092a51" }}
                        >
                          {t("PortManagementScreenContent.Title")}
                        </h5>
                        <div className="m-1 flex" onClick={this.NewitemNav}>
                          <span className="mt-1">{t("ShipManagementContent.Add")}</span>
                          <AddIcon />
                        </div>
                      </div>
                    </div>
                    <div className="search-filter-box">
                      <div className="row">
                        <div
                          className={showSidePane ? "col-lg-4" : "col-lg-4"}
                        >
                          <label className="form-label">{t("TopPaneContent.Port")}</label>
                          <br></br>
                          <input
                            className="form-control"
                            type="text"
                            name="PortName"
                            value={this.state.searchData.PortName}
                            placeholder={t("TopPaneContent.Port")}
                            onChange={(e) => this.handleInputChange(e)}
                          ></input>
                        </div>
                        <div
                          className={showSidePane ? "col-lg-4" : "col-lg-4"}
                        >
                          <label className="form-label">{t("EquipmentServiceTypes.Country")}</label>
                          <br></br>
                          <input
                            className="form-control"
                            type="text"
                            name="Country"
                            value={this.state.searchData.Country}
                            placeholder={t("EquipmentServiceTypes.Country")}
                            onChange={(e) => this.handleInputChange(e)}
                          ></input>
                        </div>
                        <div className={showSidePane ? "col-lg-4" : "col-lg-4"}>
                          <label className="form-label">{t("ZoneScreen.Title")}</label>
                          <br></br>
                          <select
                            className="form-control"
                            name="Zone"
                            value={this.state.searchData.Zone}
                            onChange={(e) => this.handleInputChange(e, "Zone")}
                          >
                            <option value="">{t("VendorManagementScreenContent.SelectZone")}</option>
                            {this.state.zoneListData?.length > 0 &&
                              this.state.zoneListData?.map((zonename) => (
                                <option value={zonename.lookUpId}>
                                  {zonename.lookUpName}
                                </option>
                              ))}
                          </select>
                        </div>
                        {/*  <div
                          className={showSidePane ? "col-lg-4 " : "col-lg-4"}
                        >
                          <label className="form-label">Type</label>
                          <br></br>
                          <Multiselect
                             options={portTypeList??[]} 
                            isObject={false}
                            style={{
                              option: {
                                "margin-right": 0,
                                display: "block",
                                "font-weight": "normal",
                              },
                              chips: { "background-color": "#1a3464" },
                            }}
                            onSelect={(item) => this.onSelectChange(item)}
                            onRemove={(item) => this.onRemoveChange(item)}
                            showArrow={true}
                            selectedValues={this.state.searchData.PortType}
                            placeholder={
                              this.state.Ships && this.state.Ships.length
                                ? ""
                                : "Select"
                            }
                            closeIcon="cancel"
                          />
                        </div> */}
                        <div
                          className={showSidePane ? "col-lg-12" : "col-lg-12"}
                        >
                          <div
                            className="form-group search-btn-col mt-4"
                            style={{ textAlign: "end" }}
                          >
                            <button
                              className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                              type="submit"
                              onClick={() => this.SearchPort1(1)}
                            >
                              {" "}
                              {t("content.Search")}{" "}
                            </button>
                            <button
                              className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                              type="button"
                              onClick={() => this.ClearInput()}
                            >
                              {" "}
                              {t("content.Clear")}{" "}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {PortList ? (
                <PortCard
                  currentPage={(PortList.pagination.currentPage - 1) * PortList.pagination.pageSize}
                  arraylist={PortList.data}
                  totalRecords={
                    PortList.pagination?.totalcount
                      ? PortList.pagination?.totalcount
                      : 0
                  }
                  pageSize={PortList.pagination?.pageSize}
                  setUpdatedState={(value) => this.SearchPort(value)}
                  eyeclick={(item) => this.eyeclick(item)}
                  deletePort={(item) => this.deletePort(item)}
                />
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
  openEditScreen() {
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.push("/Home/EditClient");
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan,
    PortList: state.MasterScreenReducer.PortList,
    portSearch: state.MasterScreenReducer.portSearch,
    zoneList: state.VendorManagementReducer.zoneList,
    /*     portTypeList: state.MasterScreenReducer.PortType || [], */
  };
}
export default withTranslation()(withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PortManagement)));
